import React, { useContext } from 'react';

import { ReceiptsApi } from '../apis';
import { api } from '../api';

const ReceiptsApiContext = React.createContext(new ReceiptsApi(api));

export const ReceiptsApiProvider = ReceiptsApiContext.Provider;
export const useReceiptsApi = (): ReceiptsApi => useContext(ReceiptsApiContext);
